import { Icon } from './_Icon';
export const CardIcon = (props) => <Icon {...props} d="M2 5h20v14H2z M2 10h20" />;
